<template>
  <div class="videoInfoPage">
    <headerCom :headerBlue="headerBlue" ref="headerComDom"></headerCom>
    <div class="main-container">
      <!-- 页面路径--->
      <div class="main-content">
        <div class="main-crumb-container">
          <div class="main-crumb-content">
            <div class="main-crumb-txt" @click="toHome($event)">首页</div>
            <img class="main-crumb-icon" src="../assets/navbar_right arrow.png">
            <div class="main-crumb-txt" @click="toVideo(0,$event)">视频</div>
            <img class="main-crumb-icon" src="../assets/navbar_right arrow.png">
            <div class="main-crumb-txt">{{title}}</div>
            <div class="clearboth"></div>
          </div>
        </div>
      </div>
      <!--视频内容 -->
      <div class="main-content">
        <div class="main-video-info-container">
          <div class="main-video-info">
            <div class="main-video-info-title">{{title}}</div>
            <div class="main-video-info-tag-container">
              <div class="main-video-info-tag">薪领航管理咨询有限公司</div>
              <div class="main-video-info-tag">播放数：{{readQuantitie}}</div>
              <div class="clearboth"></div>
            </div>
            <div class="main-video-info-content">
              <video class="main-video-resource" :src="videoSrc" :poster="videoPosterPath"
                webkit-playsinline="true" autoplay controls="true" playsinline="true" muted="true" loop="loop" >
                视频加载失败。
              </video>
            </div>
          </div>
          <div class="main-video-info-line"></div>
        </div>
        <div class="main-video-info-relate-container">
          <div class="main-video-info-relate-title">相关标签</div>
          <div class="main-video-info-relate-category-container">
            <div class="main-video-info-relate-category" v-for="v in relateCategory" @click="toVideo(v.id,$event)">{{v.name}}</div>
            <div class="clearboth"></div>
          </div>
          <div class="main-video-info-relate-title">视频介绍</div>
          <div class="main-video-info-relate-introduce" v-html="content"></div>
        </div>
        <div class="clearboth"></div>
      </div>
      <!-- 相关视频 -->
      <div class="main-content">
        <div class="main-content-title-container">
          <div class="main-content-title">相关视频</div>
          <div class="clearboth"></div>
        </div>
        <div class="main-video-container">
          <div class="main-video" v-for="(v,index) in relateHrData.slice(0,3)" @click="toVideoInfo(v.id,$event)">
            <div class="main-video-media-container">
              <video class="main-video-media-file" :src="v.videoSrc" :poster="v.videoPosterPath" onloadedmetadata="getVideoTime(this)"></video>
              <!--<img class="main-video-media-file" src="../assets/viedoPage_img_random.png">-->
              <div class="main-video-media-browse-container">
                <img class="main-video-media-browse-img" src="../assets/videoCard_icon_views.png">
                <div class="main-video-media-browse">已播放{{v.readQuantitie}}次</div>
                <div class="clearboth"></div>
              </div>
              <div class="main-video-media-time videoTimeTxt"></div>
            </div>
            <div class="main-video-content">
                <div class="main-video-category-container">
                  <div class="main-video-category" v-for="vc in v.categoryData">{{vc.name}}</div>
                  <div class="clearboth"></div>
                </div>
                <div class="main-video-title">{{v.title}}</div>
            </div>
            <div class="clearboth"></div>
          </div>

          <div class="clearboth"></div>
        </div>
        <div class="main-video-more-container">
          <div class="main-video-more" @click="toVideo(0,$event)">
            查看更多视频
            <img class="main-icon-more" src="../assets/icon_more.png" />
          </div>
        </div>
      </div>
    </div>

    <foot></foot>

  </div>

</template>

<script>
  import headerCom from '@/components/Header.vue'
  import foot from '@/components/Footer.vue'
  import axios from "axios";

  export default {
    data() {
      return {
        headerBlue: true,
        id: 0,
        title: "",
        readQuantitie: 0,
        videoSrc: "",
        videoPosterPath: "",
        content: "",
        intro: "",
        relateHrData: [],
        relateCategory: [],
      }
    },
    components: {
      headerCom,
      foot
    },
    created() {
      document.documentElement.scrollTop = 0;
      this.id = this.$route.query.id
      let params = {};
      params.id = this.id;
      axios
        .get("pilotage/videoById", {params: params})
        .then((res) => {
          if(res!=null && res.data!=null){
            if(res.data.hrData!=null){
              this.title = res.data.hrData.title
              document.title = this.title + '_薪领航管理咨询有限公司';
              if(res.data.hrData.readQuantitie!=null){
                this.readQuantitie = res.data.hrData.readQuantitie
              }

              this.videoSrc = res.data.hrData.videoSrc
              this.intro = res.data.hrData.intro
              this.content = res.data.hrData.content
              this.videoPosterPath = res.data.hrData.videoPosterPath
            }
            if(res.data.relateCategory!=null){
              for(let i=0;i<res.data.relateCategory.length;i++){
                this.relateCategory.push({id: res.data.relateCategory[i].lawLabelId, name: res.data.relateCategory[i].lawLabelName})
              }
            }

            if(res.data.relateHrData!=null){
              for(let j=0;j<res.data.relateHrData.length;j++){
                let id = res.data.relateHrData[j].id
                let title = res.data.relateHrData[j].title
                let content = res.data.relateHrData[j].content
                let readQuantitie = 0
                if(res.data.relateHrData[j].readQuantitie!=null){
                  readQuantitie = res.data.relateHrData[j].readQuantitie
                }

                let videoSrc = res.data.relateHrData[j].videoSrc
                let videoPosterPath = res.data.relateHrData[j].videoPosterPath

                //视频标签
                let categoryData = []
                if(res.data.relateHrData[j].articleLabelList!=null){
                  for(let k=0;k<res.data.relateHrData[j].articleLabelList.length;k++){
                    let categoryId = res.data.relateHrData[j].articleLabelList[k].lawLabelId
                    let categoryName = res.data.relateHrData[j].articleLabelList[k].lawLabelName
                    categoryData.push({id:categoryId,name:categoryName})
                  }
                }
                this.relateHrData.push({id:id,title:title,content:content,readQuantitie:readQuantitie,categoryData:categoryData,videoSrc:videoSrc,videoPosterPath:videoPosterPath})
              }
            }
          }
        })
        .catch((res) => {});

    },
    mounted() {
      document.addEventListener("click", (e) => {
        let scrollTop = document.documentElement.scrollTop;
        let x = e.x;
        let y = Math.floor(e.y + scrollTop);
        this.$refs.headerComDom.toVisitPage(this.$route.path,this.$route.path,0,0,x,y);
      });
    },
    methods: {
      //跳转视频详情页
      toVideoInfo(id,e){
        let scrollTop = document.documentElement.scrollTop;
        let x = e.x;
        let y = Math.floor(e.y + scrollTop);
        this.$refs.headerComDom.toVisitPage(this.$route.path,'/videoInfo',0,id,x,y);
        this.id = id
        let params = {};
        params.id = this.id;
        axios
          .get("pilotage/videoById", {params: params})
          .then((res) => {
             this.relateHrData = []
             this.relateCategory = []
            if(res!=null && res.data!=null){
              this.relateHrData = []
              this.relateCategory = []
              if(res.data.hrData!=null){
                this.title = res.data.hrData.title
                if(res.data.hrData.readQuantitie!=null){
                  this.readQuantitie = res.data.hrData.readQuantitie
                }

                this.content = res.data.hrData.content
                this.videoPosterPath = res.data.hrData.videoPosterPath
              }
              if(res.data.relateCategory!=null){
                for(let i=0;i<res.data.relateCategory.length;i++){
                  this.relateCategory.push({id: res.data.relateCategory[i].lawLabelId, name: res.data.relateCategory[i].lawLabelName})
                }
              }
              if(res.data.relateHrData!=null){
                for(let j=0;j<res.data.relateHrData.length;j++){
                  let id = res.data.relateHrData[j].id
                  let title = res.data.relateHrData[j].title
                  let content = res.data.relateHrData[j].content
                  let readQuantitie = 0
                  if(res.data.relateHrData[j].readQuantitie!=null){
                    readQuantitie = res.data.relateHrData[j].readQuantitie
                  }

                  let videoSrc = res.data.relateHrData[j].videoSrc
                  let videoPosterPath = res.data.relateHrData[j].videoPosterPath


                  //视频标签
                  let categoryData = []
                  if(res.data.relateHrData[j].articleLabelList!=null){
                    for(let k=0;k<res.data.relateHrData[j].articleLabelList.length;k++){
                      let categoryId = res.data.relateHrData[j].articleLabelList[k].lawLabelId
                      let categoryName = res.data.relateHrData[j].articleLabelList[k].lawLabelName
                      categoryData.push({id:categoryId,name:categoryName})
                    }
                  }
                  this.relateHrData.push({id:id,title:title,content:content,readQuantitie:readQuantitie,categoryData:categoryData,videoSrc:videoSrc,videoPosterPath:videoPosterPath})
                }
              }

              document.documentElement.scrollTop = 0;
            }
          })
          .catch((res) => {});
      },
      //相关标签跳转动态页
      toVideo(lawLabelId,e){//0全部标签
        let scrollTop = document.documentElement.scrollTop;
        let x = e.x;
        let y = Math.floor(e.y + scrollTop);
        this.$refs.headerComDom.toVisitPage(this.$route.path,'/video',0,0,x,y);
        this.$router.push({name:'video',params:{lawLabelId:lawLabelId}})
      },
      //跳转首页
      toHome(e){
        let scrollTop = document.documentElement.scrollTop;
        let x = e.x;
        let y = Math.floor(e.y + scrollTop);
        this.$refs.headerComDom.toVisitPage(this.$route.path,'/',0,0,x,y);
        this.$router.push('/');
      },
    },
  }
</script>

<style>
  .videoInfoPage .main-content:first-child{
    padding-top: 0;
  }
  .main-video-info-container{
    float: left;
    margin: 0 0 0 178px;
    width: calc(69% - 180px);
    position: relative;
  }
  .main-video-info{
    float: left;
    width: calc(100% - 77px);
  }
  .main-video-info-title{
    font-weight: 500;
    font-size: 36px;
    line-height: 38px;
    color: #333333;
  }
  .main-video-info-tag-container{
    margin: 20px 0 0 0;
  }
  .main-video-info-tag{
    font-size: 16px;
    line-height: 28px;
    color: #4F617E;
    float: left;
    margin-right: 50px;
  }
  .main-video-info-content{
    margin: 30px 0 0 0;
  }
  .main-video-resource{
    width: 100%;
    height: auto;
  }
  .main-video-info-line{
    position: absolute;
    height: calc(100% - 80px);
    top: 80px;
    right: 0;
    background: #E7EEF9;
    width: 1px;
  }
  .main-video-info-relate-container{
    float: left;
    width: calc(31% - 100px);
    margin: 80px 0 0 20px;
  }
  .main-video-info-relate-title{
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    color: #333333;
    margin: 30px 0 0 0;
  }
  .main-video-info-relate-title:first-child{
    margin-top: 0px;
  }
  .main-video-info-relate-category-container{
    margin: 16px 0 0 0;
  }
  .main-video-info-relate-category{
    font-size: 12px;
    line-height: 16px;
    color: #1055C1;
    background: #E7EEF9;
    border-radius: 4px;
    padding: 4px 10px;
    float: left;
    margin: 0 0 0 8px;
    cursor: pointer;
  }
  .main-video-info-relate-category:first-child{
    margin-left: 0px;
  }
  .main-video-info-relate-introduce{
    font-size: 16px;
    line-height: 32px;
    color: #4F617E;
    margin: 16px 0 0 0;
  }
  .main-video-info-relate-introduce p{
    margin: 0;
    padding: 0;
  }

  .main-video-container{
    margin: 40px 0 0 0;
  }
  .videoInfoPage .main-video:nth-of-type(-3n+4){
    margin-left: 180px;
  }

  .main-video-more{
    font-size: 16px;
    line-height: 23px;
    text-align: center;
    color: #1055C1;
    cursor: pointer;
    position: relative;
    margin: 60px 0 0 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/videoInfo.vue